<template>
  <form @submit.prevent="saveForm()">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head flex justify-between">
        <p class="modal-card-title">
          {{ file ? 'Update' : 'Add' }} HTML/Embed
        </p>
      </header>
      <section class="modal-card-body">
          <d-field label="Name">
              <d-input v-model="form.name" required />
          </d-field>
          <d-field label="Content">
              <l-html-editor 
                ref="htmlEditor" 
                v-model="form.content" 
                :upload-endpoint="'/api/images'"
                :max-file-size="10485760"
                :allowed-types="['image/jpeg', 'image/png', 'image/gif', 'image/webp']"
              />
          </d-field>
          <p>Optionally enter a minimum amount of time the user has to spend on this content in minutes.<br />E.g. - 0.5 = 30 seconds. 2 = 2 minutes.</p>
          <d-field label="Minimum Time">
              <d-input v-model="form.minimumMinutes" />
          </d-field>
      </section>
      <footer class="modal-card-foot justify-end">
        <d-btn flat @click="$emit('close')">
          Cancel
        </d-btn>
        <d-btn :loading="saving" type="submit">
          {{ file ? 'Update' : 'Add' }}
        </d-btn>
      </footer>
    </div>
  </form>
</template>

<script>
  import { createItem, updateItem } from '@resources/scripts/services/contentListingItemsApi.service';
  import { ListingItemType } from '@resources/scripts/constants';
  import { showErrorToast } from '@services/errorHandling.service';

  export default {
    props: {
      contentListing: {
        type: Object,
        default: () => ({}),
      },
      file: {
        type: Object,
        default: null,
      },
    },

    emits: ['close', 'saved'],

    data() {
      return {
        saving: false,
        form: {
          name: '',
          content: '',
          description: '',
          minimumMinutes: '',
          categorized: true,
          type: ListingItemType.EMBEDDED,
        },
      };
    },

    mounted() {
      if (this.file) {
        this.form = JSON.parse(JSON.stringify(this.file));
      }
    },

    methods: {
      async saveForm() {
            this.saving = true;

            if (this.form.minimumMinutes == null || this.form.minimumMinutes == '') {
                this.form.minimumMinutes = 0;
            }

        try {
          if (this.file) {
            await updateItem(this.form.id, this.form, this.contentListing.type);
          } else {
            await createItem(this.form, this.contentListing.id, this.contentListing.type);
          }
          this.$emit('saved');
          this.$emit('close');
        } catch (error) {
          showErrorToast(error);
        } finally {
          this.saving = false;
        }
      },
    },
  };
</script>